<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="items[0] ? items[0].parent.name : ''" @back="back">
            <common-training-header :in-header="true" :user_hash="attendant"/>
        </a-page-header>

        <a-row :gutter="[16,16]">
            <a-col :span="24">
                <a-card type="inner" size="small">
                    <a-skeleton :loading="loading" active>
                        <a-table class="pcp-table" :dataSource="data.items" rowKey="id" :pagination="false" bordered>
                            <a-table-column :width="80" key="number"  title="No"  class="align-center text-center">
                                <template slot-scope="r,i,n">
                                    <strong>{{ n + 1}}</strong>
                                </template>
                            </a-table-column>

                            <a-table-column key="component" className="align-center text-left">
                                <span slot="title" class="text-left">Komponen Evaluasi</span>
                                <template slot-scope="record">
                                    {{ record.name }}
                                </template>
                            </a-table-column>

                            <a-table-column key="level" title="Rating" className="align-center text-small text-left">
                                <template slot-scope="record">
                                    <div class="text-center">
                                        <a-rate v-model="record.score" :disabled="! edited" />
                                    </div>
                                </template>
                            </a-table-column>

                            <a-table-column :width="80" key="score" title="Score" className="align-center text-small text-center">
                                <template slot-scope="record">
                                    <strong>{{ record.score }}</strong>
                                </template>
                            </a-table-column>
                        </a-table>
                        <br>
                        <a-divider orientation="left">Kritik & Saran</a-divider>
                        <br>
                        <a-comment>
                            <span slot="author"><strong>{{ current_user.name }}</strong></span>
                            <a-avatar slot="avatar" :size="120" :src="current_user.photo" :alt="current_user.name" />
                            <div slot="content" style="margin-top: 24px;">
                                <template v-if="edited">
                                    <a-textarea :rows="4" v-model="data.comment" placeholder="Kritik & Saran" />
                                </template>
                                <template v-else>
                                    {{ data.comment }}
                                </template>
                            </div>
                        </a-comment>

                        <template v-if="edited">
                            <a-divider />
                            <div style="margin: 24px 0;" class="text-right">
                                <a-button :disabled="processing" type="primary" :href="'javascript:void(0);'" @click="handleSubmit">Submit</a-button>
                            </div>
                        </template>
                    </a-skeleton>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
export default {
    props: {
        material_id: {
            type: Number,
            default: 0,
        },
        edited: {
            type: Boolean,
            default: false
        },
        attendant: {
            type: String,
            default: null,
        }
    },
    computed: {
        current_user() {
            return this.current_attendant === null
                ? this.$laravel.user
                : this.current_attendant
        }
    },
    created() {
        let urlParams = new URLSearchParams(window.location.search)

        this.type = urlParams.get('type')
        this.getItems()
    },
    data() {
        return {
            loading: false,
            processing: false,
            items: {},
            data: {
                items: [],
                comment: null,
            },
            type: '',
            current_attendant: null,
        };
    },
    methods: {
        getItems() {
            this.loading = true
            let params = {
                type: this.type,
                material_id: this.material_id,
                attendant: this.attendant
            }
            this.$http
                .get(this.routeUri("api.training.evaluation.show") + '?' + this.$qs.stringify(params))
                .then(r => {
                    this.items = r.data.items
                    this.current_attendant = r.data.user

                    this.items.forEach((i) => {
                        this.data.items.push({
                            id: i.id,
                            name: i.name,
                            score: i.att_training_evaluation_details ? i.att_training_evaluation_details.score : 0,
                        })
                        this.data.comment = i.att_training_evaluation_details ? i.att_training_evaluation_details.att_training_evaluation.comment : ''
                    })
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleSubmit() {
            this.processing = true

            let formData = {
                material_id: this.material_id,
                type: this.type,
                evaluate: [],
                comment: this.data.comment
            }

            this.data.items.forEach((i) => formData.evaluate.push({
                training_evaluation_id: i.id,
                score: i.score,
            }))

            this.$http.post(this.routeUri('api.training.evaluation.store'), formData)
                .then((response) => {
                    this.handleSuccessResponse(response.data)
                })
                .catch((error) => this.handleResponseError(error.response.data))
                .finally(() => this.processing = false)
        },
        handleSuccessResponse(data) {
            let successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => window.location.href = this.routeUri('admin.classical.attendant.evaluation'), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        back() {
            window.location.href = this.routeUri('admin.classical.admin.evaluation') + '?attendant=' + this.attendant
        }
    }
}
</script>

<style lang="less">
.width60{
    width: 60%;
}

.ant-comment-avatar img {
    width:  100%;
    height: 100%;
}
</style>
